<app-navbar class="home" [show_cart]="is_alacarte" [hide_menu]="is_alacarte"
    [home_address]="getHomeAddress()"></app-navbar>

<section class="first-section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6">

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_WEDDING === qr_category_use_case">
                    <h1 class="lg">Capture the Chaos, Curate the Joy: <span>Capturing Wedding Memories</span> Made
                        Easy
                        with a QR Code.</h1>
                    <p class="mb-n1">Relive, not just remember!</p>
                    <p>
                        Guests upload to your beautiful wedding gallery with our Memories QR Code. Capture every
                        moment,
                        every angle, and share the magic forever.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_BIRTHDAY === qr_category_use_case">
                    <h1 class="lg">Make Your Birthday Unforgettable: <span>Capture Every Moment</span> with a
                        Memories QR Code.
                    </h1>
                    <p class="mb-n1">Birthdays fly by!</p>
                    <p>
                        Capture every laugh with our Memories QR Code. Guests upload to your beautiful birthday
                        gallery with our
                        Memories QR Code. Capture every moment, every angle, and share the magic forever.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CORPORATE === qr_category_use_case">
                    <h1 class="lg">Capture the Spark: <span>Make Your Corporate Event Shine</span> with a
                        Memories QR Code.
                    </h1>
                    <p>
                        Corporate events are all about connection and celebrating wins, but the energy can fade
                        fast. Our Memories QR Code changes that! Capture the spirit of the event with guest photos &
                        videos, creating a lasting record of the connections and achievements.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_FAMILY_REUNIONS === qr_category_use_case">
                    <h1 class="lg">Reunite, Reminisce, Rejoice: <span>Capture Your Family Reunion</span> with
                        Memories QR Code.
                    </h1>
                    <p class="mb-n1">Laughter, love, memories!</p>
                    <p>
                        Our Memories QR Code captures every moment from
                        all angles in a shared online gallery. Relive the joy, forever.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_PROMS === qr_category_use_case">
                    <h1 class="lg">Prom Night Magic: <span>Capture Every Momory</span> with
                        Memories QR Code.
                    </h1>
                    <p class="mb-n1">Don't miss a single sequin or smile!</p>
                    <p>
                        Our Memories QR Code lets everyone at prom upload photos and videos to a shared online
                        gallery.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_BACHELORETTE === qr_category_use_case">
                    <h1 class="lg">Pop the Bubbly, Share the Fun: <span>Celebrate Your Bachelorette Party</span>
                        with
                        Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the hassle of collecting photos from different sources!</p>
                    <p>
                        Our Memories QR Code creates a shared online gallery brimming with epic moments, squad love,
                        and all the fun of your bachelorette party.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_BABY_SHOWER === qr_category_use_case">
                    <h1 class="lg">Celebrate the Little One: <span>Shower Your Baby Shower</span>
                        with
                        Memories with a Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the hassle of collecting photos from different sources!</p>
                    <p>
                        Our Memories QR Code creates a beautiful, shared gallery overflowing with love, well wishes,
                        and precious moments from your baby shower.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_HOLIDAY === qr_category_use_case">
                    <h1 class="lg">Deck the Halls with Memories: <span>Capture the Holiday Cheer</span>
                        with a Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the endless photo-collecting frenzy!</p>
                    <p>
                        Our Memories QR Code creates a beautiful, shared gallery overflowing with precious moments
                        and the true magic of the holidays.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHRISTMAS === qr_category_use_case">
                    <h1 class="lg">Capture the Joy of Christmas: <span>Share the Light</span>
                        with a Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the endless photo-collecting frenzy!</p>
                    <p>
                        Our Memories QR Code creates a beautiful, shared gallery overflowing with festive moments,
                        heartwarming messages,
                        and the true magic of Christmas.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_SPORT_CEREMONIES === qr_category_use_case">
                    <h1 class="lg">Goal: <span>Capture Every Key Moments</span>
                        with a Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the hassle of chasing down photos!</p>
                    <p>
                        Our Memories QR Code creates a shared online gallery brimming with epic plays, team spirit,
                        and all the fun of your sport event.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CONCERT === qr_category_use_case">
                    <h1 class="lg">Rock the Memories: <span>Capture Every Encore</span>
                        with a Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the hassle of collecting photos from different sources!</p>
                    <p>
                        Our Memories QR Code creates a shared online gallery brimming with epic plays, music love,
                        and the true energy of your concert experience.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHARITY === qr_category_use_case">
                    <h1 class="lg">Capture the Cause: <span>Share the Impact of Your Charity Event</span>
                        with a Memories QR Code.
                    </h1>
                    <p class="mb-n1">Skip the hassle of collecting photos from different sources!</p>
                    <p>
                        Our Memories QR Code creates a shared online gallery overflowing with inspiring moments,
                        community spirit, and a visual testament to the impact of your charity event.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.RESTAURANT_MENU === qr_category_use_case">
                    <h1 class="lg">Upgrade Your Dining Experience with <span>Dynamic Restaurant Menus</span>.</h1>
                    <p>
                        A cutting-edge solution for modern dining experiences.
                        Our dynamic QR code technology revolutionizes how restaurants present their menus, providing
                        a seamless, interactive, and efficient way for guests to explore your culinary offerings.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.IMAGES_REAL_ESTATE === qr_category_use_case">
                    <h1 class="lg">Transform Your Real Estate Listings with <span>Dynamic Menus</span>.</h1>
                    <p>
                        An innovative solution designed to revolutionize how you present real estate properties. Our
                        dynamic QR code technology enhances property listings by providing potential buyers with
                        instant, detailed, and interactive information.
                    </p>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.VCARD_PRO_COMPANY_PROFILE === qr_category_use_case">
                    <h1 class="lg">Instantly share your <span>company profile info with a scan</span>.</h1>
                    <p>
                        Use branded vCard Pro QR codes to
                        store your company info for easy access. Update anytime, scans last forever.
                    </p>
                </ng-container>

                <ng-container *ngIf="products && !products.length; else buyNow">
                    <a class="btn btn-secondary btn-lg mb-5" routerLink="/auth/signup">
                        SIGN UP FOR FREE
                        <i class="bi bi-arrow-right ms-2"></i>
                    </a>
                </ng-container>
            </div>
            <div class="col-md-6 mt-5 mt-md-0">
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_WEDDING === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-wedding-photos.gif"
                        alt="QR Code for wedding photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_BIRTHDAY === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-birthday-parties.gif"
                        alt="QR Code for birthday photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CORPORATE === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-corporate-events.gif"
                        alt="QR Code for corporate event photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_FAMILY_REUNIONS === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-family-reunions.gif"
                        alt="QR Code for family reunion photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_PROMS === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-school-proms.gif"
                        alt="QR Code for prom night photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_BACHELORETTE === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-bachelorette-parties.gif"
                        alt="QR Code for bachelorette photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_BABY_SHOWER === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-baby-showers.gif"
                        alt="QR Code for baby showers' photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_HOLIDAY === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-holiday-photos.gif"
                        alt="QR Code for holiday photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHRISTMAS === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-christmas-photos.gif"
                        alt="QR Code for christmas photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_SPORT_CEREMONIES === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-sports-award-ceremonies.gif"
                        alt="QR Code for sports photos" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CONCERT === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-concerts.gif" alt="QR Code for concert photos"
                        width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHARITY === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-charity.gif" alt="QR Code for charity photos"
                        width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.RESTAURANT_MENU === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-restaurant-menu.gif"
                        alt="QR Code for restaurant menu" width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.IMAGES_REAL_ESTATE === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-real-estate.gif" alt="QR Code for real estate"
                        width="100%" />
                </ng-container>
                <ng-container *ngIf="qr_category_use_cases.VCARD_PRO_COMPANY_PROFILE === qr_category_use_case">
                    <img loading="lazy" src="assets/products/qr-code-for-company-profile.gif"
                        alt="QR Code for company profile" width="100%" />
                </ng-container>
            </div>
        </div>
    </div>
</section>

<section class="second-section">
    <img loading="lazy" src="assets/landing/pattern-top-darker.png" class="pattern-top">
    <div class="container">
        <div class="row align-items-center">
            <ng-container *ngIf="qr_category_use_cases.MEMORIES_WEDDING === qr_category_use_case">
                <div class="col-md-6">
                    <p>Capture and Share Your Wedding Memories Effortlessly!</p>
                    <h1 class="lg">Make your wedding unforgettable with Memories, our innovative QR code system that
                        lets your <span>wedding guests upload photos and videos</span> directly to a centralised
                        online
                        gallery.</h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-wedding-photos.jpeg"
                        alt="QR Code for wedding photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_BIRTHDAY === qr_category_use_case">
                <div class="col-md-6">
                    <p>Capture and Share Your Birthday Memories Effortlessly!</p>
                    <h1 class="lg">Make your birthday unforgettable with Memories, our innovative QR code system
                        that
                        lets your <span>birthday guests upload photos and videos</span> directly to a centralised
                        online
                        gallery.</h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-birthday-parties.png"
                        alt="QR Code for wedding photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CORPORATE === qr_category_use_case">
                <div class="col-md-6">
                    <p>Capture and Share Your Conference Memories Effortlessly!</p>
                    <h1 class="lg">Make your conference unforgettable with Memories, our innovative QR code system
                        that
                        lets your <span>conference guests upload photos and videos</span> directly to a centralised
                        online
                        gallery.</h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-corporate-events.png"
                        alt="QR Code for corporate event photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_FAMILY_REUNIONS === qr_category_use_case">
                <div class="col-md-6">
                    <p>Bridging Generations!</p>
                    <h1 class="lg">
                        A Shared Family Reunion Gallery that connects generations and <span>creating lasting
                            memories</span>. Our
                        Memories QR Code bridges the gap!
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-family-reunions.png"
                        alt="QR Code for family reunion photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_PROMS === qr_category_use_case">
                <div class="col-md-6">
                    <p>Prom night magic!</p>
                    <h1 class="lg">
                        Capture the glamour, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the
                        magic of prom night, forever.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-school-proms.png"
                        alt="QR Code for family reunion photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_BACHELORETTE === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single moment from your bachelorette party slip away!</p>
                    <h1 class="lg">
                        Capture the glamour, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the magic of your bachelorette party, forever.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-bachelorette-parties.png"
                        alt="QR Code for bachelorette party photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_BABY_SHOWER === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single moment from your baby shower party slip away!</p>
                    <h1 class="lg">
                        Capture the glamour, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the magic of your baby shower party, forever.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-baby-showers.png"
                        alt="QR Code for baby shower photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_HOLIDAY === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single joyful moment from your holiday celebrations slip away!</p>
                    <h1 class="lg">
                        Capture the glamour, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the magic of your holidays, forever.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-holiday-photos.png"
                        alt="QR Code for holiday photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHRISTMAS === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single sacred or joyful moment from your Christmas and religious gatherings slip
                        away!</p>
                    <h1 class="lg">
                        Capture the glamour, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the magic of your Christmas celebration, forever.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-christmas-photos.png"
                        alt="QR Code for christmas photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_SPORT_CEREMONIES === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single exciting moment from your football or sports gatherings slip away!</p>
                    <h1 class="lg">
                        Capture every cheer, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the thrill of your sports events for years to come.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-sports-award-ceremonies.png"
                        alt="QR Code for sport photos" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CONCERT === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single electrifying moment from your concert slip away!</p>
                    <h1 class="lg">
                        Capture every cheer, the fun, and the <span>unforgettable moments</span> from every angle.
                        Relive the thrill of your concert for years to come.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-concerts.png" alt="QR Code for concert photos"
                        width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHARITY === qr_category_use_case">
                <div class="col-md-6">
                    <p>Don’t let a single heartwarming moment from your charity event fade away!</p>
                    <h1 class="lg">
                        Capture every act of kindness, every smile, and the <span>unforgettable moments</span> from
                        every angle.
                        Relive the thrill of your charity event for years to come.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center">
                    <img loading="lazy" src="assets/products/qr-code-for-charity.png" alt="QR Code for charity photos"
                        width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.RESTAURANT_MENU === qr_category_use_case">
                <div class="col-md-6">
                    <p>Transform your dining experience with BrandQRCodes.com today!</p>
                    <h1 class="lg">Embrace the future of dining and stay ahead of the competition with our
                        <span>dynamic QR Code menus</span>.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center img-container">
                    <img loading="lazy" src="assets/products/qr-code-for-restaurant-menu.png"
                        alt="QR Code for restaurant menu" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.IMAGES_REAL_ESTATE === qr_category_use_case">
                <div class="col-md-6">
                    <p>Transform your real estate experience with BrandQRCodes.com today!</p>
                    <h1 class="lg">Embrace the future and stay ahead of the competition with our
                        <span>dynamic QR Codes</span>.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center img-container">
                    <img loading="lazy" src="assets/products/qr-code-for-real-estate.png"
                        alt="QR Code for real estate menu" width="90%" />
                </div>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.VCARD_PRO_COMPANY_PROFILE === qr_category_use_case">
                <div class="col-md-6">
                    <p>We offer a professional way to easily create and share dynamic company profiles with a QR Code.
                    </p>
                    <h1 class="lg">Our <span>vCard Pro QR codes</span> enhance networking with comprehensive contact
                        details
                        and real-time updates.
                    </h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 text-center img-container">
                    <img loading="lazy" src="assets/products/qr-code-for-company-profile.png"
                        alt="QR Code for company profile" width="90%" />
                </div>
            </ng-container>

        </div>
    </div>
    <app-core-products-menu *ngIf="is_alacarte" [qr_category]="qr_category"></app-core-products-menu>
    <img loading="lazy" src="assets/landing/pattern-bottom-darker.png" width="30%" class="pattern-bottom">
</section>

<section class="features">
    <div class="container">
        <div class="d-flex flex-column justify-items-center mb-5 title">
            <h1 class="xl mb-3 text-center">Benefits</h1>

            <ng-container *ngIf="qr_categories.MEMORIES === qr_category">
                <p class="text-center">
                    Skip chasing photos!
                </p>
            </ng-container>

            <ng-container *ngIf="qr_categories.RESTAURANT_MENU === qr_category">
                <p class="text-center">
                    Real-Time Updates!
                </p>

                <p class="text-center">
                    Boost efficiency, save costs, and gain data. Guests enjoy a modern, <span>interactive dining
                        experience</span>.
                </p>

            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_WEDDING === qr_category_use_case">
                <p class="text-center">
                    Wedding guests upload theirs directly to a <span>shared online gallery</span> with our Memories
                    QR
                    Code. It's a <span>curated collection of your wedding day, filled with guest-captured
                        moments</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_BIRTHDAY === qr_category_use_case">
                <p class="text-center">
                    Birthday party guests upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of your birthday, filled with guest-captured
                        moments</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CORPORATE === qr_category_use_case">
                <p class="text-center">
                    Guests upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of the event, filled with guest-captured
                        moments</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_FAMILY_REUNIONS === qr_category_use_case">
                <p class="text-center">
                    Family members upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of reunions overtime, filled with captured
                        moments by family members</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHRISTMAS === qr_category_use_case">
                <p class="text-center">
                    Every one upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of Christmas celebrations overtime, filled with captured
                        moments by every one</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_HOLIDAY === qr_category_use_case">
                <p class="text-center">
                    Everyone upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of your holidays overtime, filled with captured
                        moments by everyone</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHARITY === qr_category_use_case">
                <p class="text-center">
                    Everyone upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of your events overtime, filled with captured
                        moments by everyone</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_SPORT_CEREMONIES === qr_category_use_case">
                <p class="text-center">
                    Fans upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of your events, filled with captured
                        moments by fans</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CONCERT === qr_category_use_case">
                <p class="text-center">
                    Everyone upload theirs directly to a <span>shared online gallery</span> with our
                    Memories QR
                    Code. It's a <span>curated collection of your events, filled with captured
                        moments by everyone</span>
                    - all in one place.
                </p>
            </ng-container>

            <ng-container *ngIf="qr_category_use_cases.VCARD_PRO_COMPANY_PROFILE === qr_category_use_case">
                <p class="text-center">
                    Our vCard Pro branded QR codes link directly to a <span>dynamic digital profile</span> you create,
                    allowing you
                    to update contact details and company information in real-time with every scan.
                </p>
            </ng-container>

            <ng-container
                *ngIf="[qr_category_use_cases.MEMORIES_PROMS, qr_category_use_cases.MEMORIES_BACHELORETTE, qr_category_use_cases.MEMORIES_BABY_SHOWER].includes(qr_category_use_case)">
                <p class="text-center">
                    A Shared Gallery that creates lasting memories.
                </p>
            </ng-container>

            <div class="text-center my-5">
                <ng-container *ngIf="products && !products.length; else buyNow">
                    <a class="btn btn-secondary btn-lg" routerLink="/auth/signup">
                        SIGN UP FOR FREE
                        <i class="bi bi-arrow-right ms-2"></i>
                    </a>
                </ng-container>
            </div>
        </div>
        <div class="row g-3">
            <ng-container *ngIf="qr_categories.MEMORIES === qr_category">

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>1. Effortless Photo Sharing</h5>
                        <ng-container
                            *ngIf="![qr_category_use_cases.MEMORIES_FAMILY_REUNIONS, qr_category_use_cases.MEMORIES_CONCERT, qr_category_use_cases.MEMORIES_SPORT_CEREMONIES, qr_category_use_cases.MEMORIES_BACHELORETTE, qr_category_use_cases.MEMORIES_CHRISTMAS, qr_category_use_cases.MEMORIES_HOLIDAY].includes(qr_category_use_case); else noGuest2">
                            <p class="lg">
                                Guests can upload photos and videos instantly with just a scan - instantly
                                share
                                memories with you, other guests and their social media platforms!</p>
                        </ng-container>
                        <ng-template #noGuest2>
                            <ng-container
                                *ngIf="qr_category_use_cases.MEMORIES_FAMILY_REUNIONS === qr_category_use_case">
                                <p class="lg">
                                    Family members can upload photos and videos instantly with just a scan - instantly
                                    share
                                    memories with other family members and their social media platforms!</p>
                            </ng-container>

                            <ng-container *ngIf="qr_category_use_cases.MEMORIES_BACHELORETTE === qr_category_use_case">
                                <p class="lg">
                                    No more chasing down friends to get copies of their photos. With a simple scan,
                                    everyone can contribute their pictures and videos, making it easier than ever to
                                    compile a comprehensive gallery.</p>
                            </ng-container>

                            <ng-container *ngIf="qr_category_use_cases.MEMORIES_HOLIDAY === qr_category_use_case">
                                <p class="lg">
                                    No more chasing down family and friends to gather their photos. With a simple scan,
                                    everyone can contribute their snapshots and videos, making it easy to compile a
                                    complete collection of holiday memories.</p>
                            </ng-container>

                            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHRISTMAS === qr_category_use_case">
                                <p class="lg">
                                    No more chasing down family, friends, and congregation members to gather their
                                    photos. With a simple scan, everyone can contribute their snapshots and videos,
                                    making it easy to compile a complete collection of these meaningful moments.</p>
                            </ng-container>

                            <ng-container
                                *ngIf="qr_category_use_cases.MEMORIES_SPORT_CEREMONIES === qr_category_use_case">
                                <p class="lg">
                                    No more chasing down friends and fellow fans for their photos. With a simple scan,
                                    everyone can contribute their snapshots and videos, making it easy to compile a
                                    complete collection of your sports memories.
                                </p>
                            </ng-container>

                            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHARITY === qr_category_use_case">
                                <p class="lg">
                                    No more chasing down volunteers and participants for their photos. With a simple
                                    scan, everyone can contribute their snapshots and videos, making it easy to compile
                                    a complete collection of your event's memories.
                                </p>
                            </ng-container>

                            <ng-container *ngIf="qr_category_use_cases.MEMORIES_CONCERT === qr_category_use_case">
                                <p class="lg">
                                    No more chasing down friends and fellow fans for their photos. With a simple scan,
                                    everyone can contribute their snapshots and videos, making it easy to compile a
                                    complete collection of your concert memories.
                                </p>
                            </ng-container>
                        </ng-template>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">

                        <h5>2. Centralised Gallery</h5>
                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_WEDDING === qr_category_use_case">

                            <p class="lg">All your wedding photos and videos are gathered in one convenient location,
                                making
                                it easy to relive the moments.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_BIRTHDAY === qr_category_use_case">
                            <p class="lg">All your birthday photos and videos are gathered in one convenient location,
                                making
                                it easy to relive the moments.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_CORPORATE === qr_category_use_case">
                            <p class="lg">All your conference photos and videos are gathered in one convenient location,
                                making
                                it easy to relive the moments.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHARITY === qr_category_use_case">
                            <p class="lg">All your charity event memories are stored in one secure, online location.
                                This makes it simple to relive the heartwarming moments whenever you want, without
                                having to search through various social media platforms or messaging apps.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_FAMILY_REUNIONS === qr_category_use_case">
                            <p class="lg">All your reunion photos and videos are gathered in one convenient location,
                                making
                                it easy to relive the moments.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_CONCERT === qr_category_use_case">
                            <p class="lg">All your concert memories are stored in one secure, online location. This
                                makes it simple to relive the energy and excitement of the event whenever you want,
                                without having to sift through various social media platforms or messaging apps.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_PROMS === qr_category_use_case">
                            <p class="lg">All your prom photos and videos are gathered in one convenient location,
                                making
                                it easy to relive the moments.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_SPORT_CEREMONIES === qr_category_use_case">
                            <p class="lg">All your sports gathering memories are stored in one secure, online location.
                                This makes it simple to relive the excitement and camaraderie of the event whenever you
                                want, without having to sift through various social media platforms or messaging apps.
                            </p>
                        </ng-container>

                        <ng-container
                            *ngIf="[qr_category_use_cases.MEMORIES_BACHELORETTE, qr_category_use_cases.MEMORIES_BABY_SHOWER].includes(qr_category_use_case)">
                            <p class="lg">All your event’s memories are stored in one secure, online location. This
                                makes it easy to relive the fun whenever you want, without the hassle of sorting through
                                multiple social media accounts or messaging apps.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_HOLIDAY === qr_category_use_case">
                            <p class="lg">All your holiday photos and videos are gathered in one convenient location,
                                making
                                it easy to relive the joy of the season whenever you want, without having to sift
                                through various social media platforms or messaging apps.</p>
                        </ng-container>

                        <ng-container *ngIf="qr_category_use_cases.MEMORIES_CHRISTMAS === qr_category_use_case">
                            <p class="lg">All your Christmas and religious gathering memories are stored in one secure,
                                online location. This makes it simple to relive the joy and reverence of the season
                                whenever you want, without having to sift through various social media platforms or
                                messaging apps.</p>
                        </ng-container>

                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>3. No App Downloads</h5>

                        <ng-container
                            *ngIf="![qr_category_use_cases.MEMORIES_FAMILY_REUNIONS, qr_category_use_cases.MEMORIES_BACHELORETTE].includes(qr_category_use_case); else noGuest3">
                            <p class="lg">All that is needed is their smartphones to capture and upload photos directly
                                to
                                your online gallery. No app download required for your guests!</p>
                        </ng-container>
                        <ng-template #noGuest3>
                            <p class="lg">All that is needed is their smartphones to capture and upload photos directly
                                to
                                your online gallery. No app download required!</p>
                        </ng-template>

                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>4. Easy Management</h5>
                        <p class="lg">Manage the gallery, download photos, and share them with ease. Customise your
                            online gallery, moderate content, and download or share photos with ease. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>5. Multiple Packages</h5>
                        <p class="lg">Big or small, we have you covered! Choose a package with the perfect access
                            time,
                            and features to match your event size and budget. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>6. Boosts Social Media Engagement</h5>
                        <ng-container
                            *ngIf="![qr_category_use_cases.MEMORIES_FAMILY_REUNIONS].includes(qr_category_use_case); else noGuest1">
                            <p class="lg">Allow social media sharing buttons within the gallery to enable guests to
                                easily
                                share their favourite event photos directly to their social media platforms.</p>
                        </ng-container>
                        <ng-template #noGuest1>
                            <p class="lg">Allow social media sharing buttons within the gallery to enable family members
                                to
                                easily
                                share their favourite event photos directly to their social media platforms.</p>
                        </ng-template>

                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="qr_categories.RESTAURANT_MENU === qr_category">
                <ng-container *ngIf="qr_category_use_cases.RESTAURANT_MENU === qr_category_use_case">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>1. Enhanced Customer Experience</h5>
                            <p class="lg">
                                Guests can browse the menu at their own pace, descriptions, and even share
                                dishes with friends.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>2. Increased Efficiency</h5>
                            <p class="lg">Update your menu instantly without reprinting – perfect for seasonal
                                changes
                                or daily specials.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>3. Reduced Costs</h5>
                            <p class="lg">Eliminate the need for physical menus, saving on printing and reprinting
                                expenses.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>4. Improved Hygiene</h5>
                            <p class="lg">Contactless menus minimize the spread of germs, promoting a safer dining
                                environment.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>5. Data & Analytics</h5>
                            <p class="lg">Gain valuable insights into customer preferences through menu item selection
                                data.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>6. Enhanced Marketing Opportunities</h5>
                            <p class="lg">Allow social media sharing buttons within the menu to enable guests to
                                easily
                                share their favourite dish directly to their social media platforms.</p>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="qr_category_use_cases.IMAGES_REAL_ESTATE === qr_category_use_case">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>1. Engaging & Interactive</h5>
                            <p class="lg">Go beyond static images and text. This dynamic format keeps potential buyers
                                captivated.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>2. Eco-Friendly</h5>
                            <p class="lg">Ditch the bulky brochures! QR codes are a sustainable way to share
                                information.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>3. Always Up-to-Date</h5>
                            <p class="lg">Listing updates are reflected instantly in the QR code, ensuring you have the
                                latest details.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>4. Easy to Share</h5>
                            <p class="lg">Spread the word! Share the QR code with friends, family, or anyone interested
                                in the property.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>5. Data & Analytics</h5>
                            <p class="lg">Gain valuable insights into customer preferences through data.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>6. Enhanced Marketing Opportunities</h5>
                            <p class="lg">Allow social media sharing buttons within the listing to enable visitors to
                                easily
                                share to their social media platforms.</p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="qr_categories.VCARD_PRO === qr_category">
                <ng-container *ngIf="qr_category_use_cases.VCARD_PRO_COMPANY_PROFILE === qr_category_use_case">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>1. Professional Branding</h5>
                            <p class="lg">
                                Create QR codes that reflect your company's unique identity with custom logos and colors
                                for a cohesive and professional look.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>2. Dynamic Updates</h5>
                            <p class="lg">Easily update your contact info and company details in real-time
                                without reprinting the QR code, ensuring users always have the latest info.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>3. Comprehensive Contact Sharing</h5>
                            <p class="lg">Share complete contact details, including social media links and website, in
                                one convenient scan, making networking more effective.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>4. Enhanced Engagement</h5>
                            <p class="lg">Encourage interactive experiences by providing quick access to your company
                                profile, fostering deeper engagement with your audience.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>5. Streamlined Information Access</h5>
                            <p class="lg">Simplify the way customers and employees find information by linking QR codes
                                to your company profile.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <div class="feature-box">
                            <h5>6. Versatile Usage</h5>
                            <p class="lg">Utilize branded QR codes across various platforms, including business cards,
                                brochures, and email signatures, to maximize reach and accessibility.</p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</section>

<div class="container my-5">
    <h2 class="my-5 text-center">Also perfect for</h2>
    <app-core-product-use-cases-wrapper [qr_category]="qr_category"></app-core-product-use-cases-wrapper>
</div>
<br>
<br>
<br>
<app-footer>
    <ng-container *ngIf="products && !products.length; else buyNow">
        <a class="btn btn-secondary btn-lg" routerLink="/auth/signup">
            SIGN UP FOR FREE
            <i class="bi bi-arrow-right ms-2"></i>
        </a>
    </ng-container>
</app-footer>

<ng-template #buyNow>
    <a class="btn btn-secondary btn-lg mb-5" routerLink="/products/{{qr_category}}">
        <i class="bi bi-cart me-2"></i>
        Buy NOW
    </a>
</ng-template>

<app-shared-bounce-modal></app-shared-bounce-modal>